import { Grid, Section } from '@gogame/components';
import TrackerFilters from './filters';
import React from 'react';

const CampaignsSection = () => (
  <Section title={'Campaigns'}>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <TrackerFilters.IncludeArchived />
      </Grid>
    </Grid>
  </Section>
);

export default CampaignsSection;
